const EuropeanCountryCodes = [
  'AL', 'AD', 'AM', 'AT', 'AZ', 'BY',
  'DE', 'FR', 'ES', 'UA', 'IE', 'FI',
  'BE', 'BA', 'BG', 'HR', 'CY', 'CZ',
  'DK', 'EE', 'GE', 'GR', 'HU', 'IS',
  'IT', 'KZ', 'LV', 'LI', 'LT', 'LU',
  'MK', 'MT', 'MD', 'MC', 'NL', 'NO',
  'PL', 'PT', 'RO', 'RU', 'SM', 'SL',
  'SI', 'SE', 'CH', 'TR', 'VA'
];

export default EuropeanCountryCodes;



// WEBPACK FOOTER //
// ./src/data/european-country-codes.js